// utils.js
// Function to store username in localStorage
let passcode = "";
let username = "";
let AttendeesData = [];
let isAdmin = false;
let currentUser = {
  "userId": "0",
  "userType": "Encora",
  "firstName": "Test",
  "lastName": "User",
  "emailId": "test@user.com",
  "designation": "Developer",
  "linkedInProfileURL": "",
  "organization": "Encora",
  "profilePhotoPath": "",
  "companyLogoPath": ""
};
let travelDetail = [];
let travelDetailAll = [];
let isTravelSave = true;

let isEventLive = false; // this variable handle event is live or virtual

export const setIsEventLive = (val) => {
  isEventLive = val;
}
export const getIsEventLive = () => {
  return isEventLive;
}

export const resetOnlogout = () => {
  //localStorage.removeItem('CAB_username');
  sessionStorage.removeItem("currentUser");
  sessionStorage.removeItem("userRole");
  sessionStorage.removeItem("sessionExpiry");
  localStorage.removeItem('cab_passcode');
  localStorage.removeItem('isAdmin');
  passcode = "";
  username = "";
  AttendeesData = [];
  isAdmin = false;
  travelDetail = [];
  travelDetailAll = [];
  isTravelSave = true;
}

export const checkApiError = (_statusCode) => {
  (_statusCode === 401) && resetOnlogout();
  return _statusCode === 401 ? true : false;
}

export const getPassCode = (val) => {
  if (val) {
    localStorage.setItem('cab_passcode', val);
    passcode = val;
    getSummitData();
  } else {
    passcode = passcode === '' ? localStorage.getItem('cab_passcode') || '' : passcode;
    return passcode;
  }
}
export const storeUsername = (_username) => {
  username = _username;
  localStorage.setItem('CAB_username', _username);
};
export const getStoreUsername = (_username) => {
  return localStorage.getItem('CAB_username') || '';
};
export const checkAdmin = (val) => {
  if (val) {
    isAdmin = val;
    localStorage.setItem('isAdmin', val);
  } else {
    isAdmin = isAdmin === false ? localStorage.getItem('isAdmin') || '' : isAdmin;
    isAdmin = (isAdmin === 'true' || isAdmin === true) ? true : false;
    return isAdmin;
  }
}
// Function to get username from localStorage
export const getUsername = () => {
  return username; // current user email id
};

export const getUserNameOpt = (opt) => {
  return opt ? currentUser[opt] : currentUser.firstName + ' ' +currentUser.lastName;
};

export const getCurrentUser = () => {
  return currentUser;
}
export const setCurrentUser = (userDetails) => {
  currentUser = userDetails;
}
// Detect device type
export const detectDeviceType = () => {
  const userAgent = navigator.userAgent;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
}

export const getAttendeesData = async (_obj, _isNot) => {
  let userData = {};
  _isNot = _isNot || false;
  if (_obj) {
    const key = Object.keys(_obj)[0];
    userData = AttendeesData.filter((attendee) => {
      if (_isNot) {
        return _obj[key] !== attendee[key];
      } else {
        return _obj[key] === attendee[key];
      }
    });
  } else {
    userData = AttendeesData;
  }
  return userData;
}

const getSummitData = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/cab/getsummitdetails`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "*/*",
        'Authorization': `Bearer ${getPassCode()}` // Passcode as Bearer token
      }
    });
    if (!response.ok) {
      throw new Error('Error');
    } else {
      const data = await response.json();
      let test = data.EncryptedData.substring(6);
      AttendeesData = JSON.parse(atob(test));
      let tempUser = AttendeesData.find((attendee) => attendee.email === username);
      if (tempUser) {
        currentUser = tempUser;
      }
    }
  } catch (error) {
    //console.error(error);
    // Handle error, e.g., display an error message to the user
    //alert('Invalid passcode. Please try again.');
  }
}
/* 
export const getTravelDetail = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/cab/Itinerary/getitinerarydetails`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getPassCode()}`
      },
      body: JSON.stringify({
        "email": document.getElementById("username").value
      })
    });

    if (!response.ok) {
      throw new Error('Error');
    } else {
      const data = await response.json();
      //travelDetail = data.iteneraryDetails;
    }
  } catch (error) {
    //console.error(error);
    // Handle error, e.g., display an error message to the user
    //alert('An error occurred while fetching travel details.');
  }
}
 */
export const getAllTravelDetail = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Itinerary/getitinerarydetails`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "*/*",
        'Authorization': `Bearer ${getPassCode()}`
      }
    });

    if (!response.ok) {
      throw new Error('Error');
    }

    const data = await response.json();
    travelDetailAll = data.iteneraryDetails;
    travelDetail = travelDetailAll.filter(user => user.emailId === username);
    if (travelDetail.length === 0) {
      isTravelSave = true;
    } else {
      isTravelSave = false;
    }
    return true;
  } catch (error) {
    //console.error(error);
    // Handle error, e.g., display an error message to the user
    //alert('An error occurred while fetching all travel details.');
  }
}
export const travelDetailSave = (bool) => {
  if(bool !== undefined){
    isTravelSave = bool;
  }else{
    return isTravelSave;
  }
}
export const getTravelDetail = (str) => {
  if (str === 'all') {
    return travelDetailAll;
  } else {
    return travelDetail;
  }
}  
